import {
  ADD_EVENT_TO_MULTI_VIEW,
  CLEAR_MULTI_VIEW,
  REMOVE_EVENT_FROM_MULTI_VIEW,
  ADD_TOAST,
  DELETE_POPUP,
  REMOVE_TOAST,
  SET_POPUP_DATA,
  UPDATE_CROSS_FILTER_DATA,
  SET_SUCCESS_BUY_CALLBACK,
  CLEAR_SUCCESS_BUY_CALLBACK,
} from '../mutationTypes';
import {getStorageItem, removeStorageItem, setStorageItem} from '@/localStorage';
import {MAX_MULTISTREAM_COUNT} from '@/const';

export const multiPlayedEventsKey = (id) => `multiPlayedEvents_${id || 'unlogged'}`;
const DEFAULT_TOAST_DATA = {
  time: 5000,
  text: 'text',
  type: 'info',
};

export default {
  [ADD_TOAST](state, data = {}) {
    const newItem = {
      ...DEFAULT_TOAST_DATA,
      id: +(new Date()),
      ...data,
    };
    state.toastList = [...state.toastList, newItem];
  },
  [REMOVE_TOAST](state, data) {
    state.toastList = state.toastList.filter((toast) => toast.id !== data.id);
  },
  [SET_POPUP_DATA](state, {props}) {
    state.popupList = [
      ...state.popupList,
      props,
    ];
  },
  [DELETE_POPUP](state, data) {
    state.popupList = state.popupList.filter((popup) => popup !== data);
  },
  [UPDATE_CROSS_FILTER_DATA](state, data) {
    state.crossFilterData = data;
  },
  [ADD_EVENT_TO_MULTI_VIEW](state, {event, userId} = {}) {
    try {
      if (!event || !event.id || state.multiPlayedEvents.length >= MAX_MULTISTREAM_COUNT) return;
      const exist = state.multiPlayedEvents.find(({id}) => id === event.id);
      if (exist) return;
      state.multiPlayedEvents.push(event);

      const storageKey = multiPlayedEventsKey(userId);
      const ids = getStorageItem(storageKey) || [];
      if (!ids.includes(event.id) && ids.length < MAX_MULTISTREAM_COUNT) {
        ids.push(event.id);
        setStorageItem(storageKey, ids);
      }
    } catch (e) {
      console.warn('ADD_EVENT_TO_MULTI_VIEW', e);
    }
  },
  [CLEAR_MULTI_VIEW](state, {userId}) {
    state.multiPlayedEvents = [];
    removeStorageItem(multiPlayedEventsKey(userId));
  },
  [REMOVE_EVENT_FROM_MULTI_VIEW](state, {clearId, userId} = {}) {
    try {
      state.multiPlayedEvents = state.multiPlayedEvents.filter(
          ({id}) => clearId !== id,
      );

      const storageKey = multiPlayedEventsKey(userId);
      const ids = getStorageItem(storageKey);
      if (ids?.includes?.(clearId)) {
        const filteredIds = ids.filter?.((id) => id !== clearId);
        filteredIds?.length ?
          setStorageItem(storageKey, filteredIds) :
          removeStorageItem(storageKey);
      }
    } catch (e) {
      console.warn('REMOVE_EVENT_FROM_MULTI_VIEW', e);
    }
  },
  [SET_SUCCESS_BUY_CALLBACK](state, callback) {
    if (state.onSuccessBuyCallback.includes(callback)) return;
    state.onSuccessBuyCallback.push(callback);
  },
  [CLEAR_SUCCESS_BUY_CALLBACK](state) {
    state.onSuccessBuyCallback = [];
  },
};
